import { useCallback, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

// Navigation-only memory, scoped to the account and URL. Nothing is written to
// localStorage, exported, or shared between accounts.
const values = new Map();
export function useRememberedState(name, initial) {
  const { user } = useAuth() || {};
  const location = useLocation();
  const key = `${user?.id || 'anonymous'}:${location.pathname}${location.search}:${name}`;
  const initialValue = () => user?.id && values.has(key) ? values.get(key) : typeof initial === 'function' ? initial() : initial;
  const [state, setState] = useState(() => ({ key, value: initialValue() }));
  const active = useRef(key); active.current = key;
  if (state.key !== key) setState({ key, value: initialValue() });
  const update = useCallback(next => {
    setState(previous => {
      const before = user?.id && values.has(key) ? values.get(key) : previous.key === key ? previous.value : undefined;
      const value = typeof next === 'function' ? next(before) : next;
      if (user?.id) { values.delete(key); values.set(key, value); }
      if (values.size > 200) values.delete(values.keys().next().value);
      return active.current === key ? { key, value } : previous;
    });
  }, [key, user?.id]);
  return [state.key === key ? state.value : initialValue(), update];
}
